import * as React from 'react';
import moment from 'moment';

const isTicking = (to: moment.Moment) => moment().isBefore(moment(to));

function getTimer(date: moment.Moment): [number, number, number, number] {
  if (!isTicking(date)) {
    return [0, 0, 0, 0];
  }

  const diff = moment.duration(date.diff(moment()));
  return [diff.days(), diff.hours(), diff.minutes(), diff.seconds()];
}

export function useCountdown(to: moment.Moment | string, onExceed?: () => void) {
  const toDate = moment(to);
  const [countdown, setCountdown] = React.useState(getTimer(toDate));
  const [ticking, toggleTicking] = React.useState(isTicking(toDate));

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getTimer(toDate));

      const isTickingNow = isTicking(toDate);
      if (ticking && !isTickingNow) {
        onExceed && onExceed();
        interval && clearInterval(interval);
      }
      toggleTicking(isTickingNow);
    }, 100);

    return () => {
      interval && clearInterval(interval);
    };
  });

  return countdown;
}
